<template>
  <div class="index-filters" :class="[{ 'is-app': isApp }]">
    <a-row :gutter="24">
      <!-- 阿拉伯语不布局占坑 -->
      <!-- <a-col
				:xs="0"
				:sm="0"
				:md="0"
				:lg="isApp ?  9 : 4"
				v-if="$i18n.locale == 'ar'"
			>
				<div></div>
			</a-col> -->
      <a-col :xs="24" :sm="12" :md="7" :lg="6" v-if="!isApp">
        <!-- <ai-select
					:options="appList"
					key-path="gameId"
					value-path="gameIdKey"
					:placeholder="$t('component.filters.appName')"
					class="select-appname filter"
					@change="handleAppListChange"
					v-model="appValue"
				></ai-select> -->
        <a-select
          show-search
          :placeholder="$t('component.filters.appName')"
          option-filter-prop="children"
          class="select-appname filter"
          :filter-option="filterOption"
          @change="handleAppListChange"
          v-model="appValue"
        >
          <a-select-option
            v-for="item in appList"
            :value="item.gameIdKey"
            :key="item.gameIdKey"
          >
            <img :src="item.icon ? item.icon : defaultIcon" />
            <span>{{ item.showName }}</span>
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="{ span: 24 }" :sm="12" :md="7" :lg="5">
        <ai-select
          :options="platformList"
          label-path="text"
          key-path="localId"
          value-path="value"
          :placeholder="$t('component.filters.allPlatform')"
          class="select-plateform filter"
          @change="handlePlateFormChange"
          v-model="plate"
        ></ai-select>
      </a-col>
      <a-col :xs="{ span: 24 }" :sm="12" :md="7" :lg="5" v-if="config.isShowLanguageSelect">
        <ai-select
          :options="languageList"
          @change="handleLanguageChange"
          label-path="languageName"
          value-path="alias"
          class="select-language filter"
          v-model="lang"
        ></ai-select>
      </a-col>
      <a-col :xs="24" :sm="24" :md="7" :lg="5">
        <a-input
          :placeholder="$t('component.filters.inputKeyword')"
          class="keyword filter"
          v-model="filterData.keyWords"
          @pressEnter="handleKeyWordsChange"
        ></a-input>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { getStorage } from "@/utils/storage.js";
import { dealShowPath } from "@/utils/path";
import { cpus } from "os";
import defaultIcon from "@/assets/defaultIcon.png";
import { mapState } from "vuex";

export default {
  name: "ai-filters",
  components: {
    aiSelect: () => import("@/components/aiSelect")
  },
  props: {
    languageList: {
      type: Array,
      default: () => []
    },
    appList: {
      type: Array,
      default: () => []
    },
    platformList: {
      type: Array,
      default: () => []
    },
    language: {
      type: [Number, String],
      default: ""
    },
    gameName: {
      type: String,
      default: ""
    },
    platform: {
      type: String,
      default: ""
    },
    appId: {
      type: String,
      default: ""
    },
    appName: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filterData: {
        gameIdKey: "", //应用名称
        platform: "", //平台
        keyWords: "", //关键字
        alias: ""
      },
      appValue: "",
      plate: "",
      lang: "",
      isApp: true,
      defaultIcon: defaultIcon
    };
  },
  computed: {
    ...mapState(["webchat"])
  },
  watch: {
    gameName: {
      handler(val) {
        this.appValue = val;
        // 将默认选中的gameIdkey 存到 bus
        val && (this.$bus.pageInfo.gameIdKey = val);
      },
      immediate: true
    },
    platform: {
      handler(val) {
        this.plate = val;
      },
      immediate: true
    },
    language: {
      handler(val) {
        this.lang = val;
      },
      immediate: true
    },
    $route(val) {
      this.clearSearch();
    }
  },
  created() {},
  mounted() {
    let { gameName, page = "", alias, key } = this.$route.params;
    this.filterData.alias = alias;
    this.filterData.gameIdKey = key;
    this.$bus.$on("clear-search", this.clearSearch);
    this.isApp = page.toLowerCase() == "app";
  },
  methods: {
    getAppName() {
      let { gameName } = this.$route.params;
      return gameName.replace(/-/g, " ");
    },
    clearSearch() {
      this.filterData.keyWords = "";
    },
    // 改变应用
    handleAppListChange(val) {
      // let { key, label } = val;
      let gameName = this.appList.find(item=>item.gameIdKey == val).showName;
      this.filterData.gameIdKey = val;
      this.$bus.pageInfo.gameIdKey = val;
      let path = this.getPath("gameIdKey", val);
       path = this.getPath("page", "apps");
       path = this.getPath("gameName", gameName);
      this.$router.push({ path });
      this.$bus.$emit("clear-search");
      if (typeof AIHelpSupport !== undefined) {
        AIHelpSupport.src&&AIHelpSupport.close();
      }
    },
    // 改变平台
    handlePlateFormChange(val) {
      let { key, label } = val;
      this.$bus.pageInfo.platform = key;
      let currentPath = this.$route.path;
      let { gameName, page, alias, gameIdKey } = this.$route.params;
      let path = `/${gameName}/${page}/${alias}/${gameIdKey}`;
      if (currentPath != path) {
        this.$router.push({ path });
      }
      this.$bus.$emit("paltform-change", key);
      this.$bus.$emit("clear-search");
      this.initH5();
    },
    initH5() {
      /*
       *	lyh 此处功能为: 某些公司需要显示h5按钮 调用h5仅需要以下几个必填参数
       *  初始化参数 参数在vuex/index.js 中
       *  language: "zh_cn",
       *  isShowH5: 0, // 根据变量是否显示打开H5入口 ture / false
       *  appId: "",
       *  appName:"",
       *  custom: '3'
       */
      this.webchat.domain = window.location.host;
      // this.webchat.domain = "aihelp.net";
      this.webchat.appKey = "appKey";
      this.webchat.language = this.language;
      //调用elvah5.init()传入初始化参数
      if (typeof AIHelpSupport !== undefined) {
        AIHelpSupport.init(this.webchat);
      }
    },
    //切换语言
    handleLanguageChange(val) {
      let { key, label } = val;
      this.filterData.alias = key;
      let path = this.getPath("alias", key);
      this.$router.push({ path });
      this.$bus.$emit("clear-search");
      // 切换语言 隐藏打开的h5窗口
      if (typeof AIHelpSupport !== undefined) {
        AIHelpSupport.src&&AIHelpSupport.close();
      }
    },
    // 搜索关键字
    handleKeyWordsChange(evt) {
      let value = evt.target.value;
      value = value.trim();
      this.filterData.keyWords = value;
      this.$emit("change-param", value);
      this.$emit("change", this.filterData);
    },
    // 返回跳转路径
    getPath(key, value) {
      let params = this.$route.params;
      params[key] = value;
      let path = "/gameName/page/alias/gameIdKey";
      Object.keys(params).forEach(key => {
        path = path.replace(key, params[key]);
      });
      return path;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[1].children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  },
  beforeDestroy() {
    this.$bus.$off("clear-search");
  }
};
</script>
<style lang="scss">
@import "~@/style/media.scss";

.index-filters {
  width: 100%;
  $margin-top: 16px;
  background: #eaecef;
  line-height: 80px;

  .ant-row {
    padding: 0 30px;
    max-width: 1200px;
    margin: 0 auto !important;
  }
  .filter {
    width: 100%;
    .ant-select-selection {
      border: none;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.8);
      .ant-select-arrow {
        color: rgba(0, 0, 0, 1.25);
      }
      .ant-select-selection-selected-value {
        color: #414650;
      }
    }
    .ant-select-open .ant-select-selection {
      box-shadow: none !important;
    }
  }
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    box-shadow: none !important;
  }
  .select-appname {
    .ant-select-selection {
      background: #eaecef;
      // .ant-select-arrow{
      //   color: rgba(0, 0, 0, 1.25);
      // }
      .ant-select-selection-selected-value {
        color: #414650;
        font-size: 18px;
        font-weight: 500;
        img {
          width: 50px;
          height: 50px;
          margin-right: 20px;
          border-radius: 5px;
        }
      }
    }
    .ant-select-selection__rendered {
      line-height: 47px;
    }
    .ant-select-selection--single {
      height: 47px;
    }
  }
  .ant-input {
    height: 35px;
    border: 1px solid #eaecef;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.8) url("../../../assets/searchIcon.png")
      no-repeat right;
    background-size: 14px;
    background-position-x: 95%;
    line-height: inherit;
  }
  @include media-xl {
    .ant-input {
      width: 260px;
    }
  }
  @include media-max-lg {
    .keyword {
      margin-top: $margin-top;
    }
  }
  @include media-max-sm {
    .keyword,
    .select-language {
      margin-top: $margin-top;
    }
  }
  @include media-xs {
    .select-plateform,
    .select-language {
      margin-top: $margin-top;
    }
  }
  .ant-input-disabled {
    color: rgba(0, 0, 0, 0.65);
  }
  &.is-app {
    @include media-max-lg {
      .keyword {
        margin-top: 0;
      }
    }
    @include media-max-sm {
      .select-language {
        margin-top: 0;
      }
      .keyword {
        margin-top: $margin-top;
      }
    }
    @include media-xs {
      .select-plateform {
        margin-top: 0;
      }
      .select-language {
        margin-top: $margin-top;
      }
    }
  }
}

.ant-select-dropdown {
  img {
    width: 34px;
    height: 34px;
    margin-right: 20px;
    border-radius: 5px;
  }
}

.AIHelpSupportBox {
  width: 340px;
  height: 500px;
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 9999;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 32px;
  -webkit-transition: all .5s ease-in;
  -moz-transition: all .5s ease-in;
  transition: all .5s ease-in;
  background-color: #fff;
}
.close {
  position: absolute;
  right: 8px;
  top: 8px;
  width: 28px;
  height: 28px;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 25px;
  cursor: pointer;
  opacity: 1;
}
.close:before {
  position: absolute;
  content: "";
  width: 20px;
  height: 2px;
  background: #fff;
  transform: rotate(45deg);
  top: 13px;
  left: 5px;
}
.close:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 2px;
  background: #fff;
  transform: rotate(-45deg);
  top: 13px;
  left: 5px;
}
</style>